import { render } from "./InvitationResponseButtons.vue?vue&type=template&id=6d3a71e6&scoped=true"
import script from "./InvitationResponseButtons.vue?vue&type=script&lang=js"
export * from "./InvitationResponseButtons.vue?vue&type=script&lang=js"

import "./InvitationResponseButtons.vue?vue&type=style&index=0&id=6d3a71e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3a71e6"]])

export default __exports__